import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import InfoForm from '../../components/InfoForm';
import styles from './NewDocumentView.m.sass';
var NewDocumentView = function NewDocumentView(_ref) {
  var view = _ref.view,
    showTags = _ref.showTags;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.root)
  }, /*#__PURE__*/React.createElement(InfoForm, {
    view: view,
    buttonText: "Upload",
    buttonDataTest: "new-document-upload-button",
    showTags: showTags
  }));
};
NewDocumentView.defaultProps = {
  showTags: true
};
export default observer(NewDocumentView);
//# sourceMappingURL=NewDocumentView.js.map
